import Card from './animation/Card'
import { gsap } from 'gsap'

class WorkMeta extends Card {
  constructor ($el, args) {
    super($el, args)

    const $img = this.$el.find('.media-item__image')

    this.$el.find('.work-card__thumb-link').hover(
      () => {
        gsap.to($img, { duration: 1, scale: 1.05, ease: 'expo.out' })
      },
      () => {
        gsap.to($img, { duration: 1, scale: 1, ease: 'expo.out' })
      }
    )
  }
}

export default WorkMeta



// WEBPACK FOOTER //
// ./scripts/components/WorkCard.js